/**
 * Site Map.js
 *
 * Handles the department dropdown and the ajax requesting for
 * the reload of the section to display the selected department.
 *
 */
export default class siteMap {

    constructor() {

        this.settings = {

            navItems: document.getElementsByClassName("site-map__nav-item--has-children"),
            activeClass: 'active-navigation-link'

        }

    }

    init() {

        if (null !== this.settings.navItems) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        let s = this.settings;


        for (var i = 0; i < s.navItems.length; i++) {

            var child = s.navItems[i].childNodes[0];

            child.addEventListener( 'click', event => {
                if (window.innerWidth < 899) {

                    this.activeClass(event.target);

                }
            });

        }

        window.addEventListener( 'resize', event => {

            for (var i = 0; i < s.navItems.length; i++) {

                var child = s.navItems[i].childNodes[0];

                if (window.innerWidth < 899) {
                    child.parentNode.classList.remove(s.activeClass);
                }

            }

        } );

    }

    activeClass( element ) {

        let s = this.settings;
        let parent = element.parentNode;

        // If the parent of 'element' has the active class, remove it!
        if ( ! parent.classList.contains(s.activeClass) ) {
            event.preventDefault();
        }

        // If the parent of 'element' has the active class, remove it!
        if (parent.classList.contains(s.activeClass)) {
            parent.classList.remove(s.activeClass);
        } else {
            // For all elements remove the active class
            // then add it to the element selected
            for (var i = 0; i < s.navItems.length; i++) {
                s.navItems[i].classList.remove(s.activeClass);
            }
            parent.classList.toggle(s.activeClass);
        }

    }

}